/* eslint-disable css-modules/no-unused-class, no-extra-boolean-cast */
import { FC } from 'react';
import { translate } from 'translations';
import { Divider, Icon, UiLibrary } from 'learning-panel-components';
import { coreService } from 'network-utils';
import InventoryItem, { InventoryItemProps as IInventoryItem } from '../inventoryItem/inventoryItem';
import styles from './inventory.module.scss';

const Inventory: FC<InventoryProps> = (props: InventoryProps) => {
    const { name, inventoryItems, maxScore, score, onClose } = props;

    const calcItems = () => {
        return Object.values(inventoryItems).reduce((total, quantity) => total + quantity, 0);
    };

    return (
        <div className={styles['inventory-wrapper']}>
            {onClose && (
                <div
                    className={styles['close-icon']}
                    onClick={e => {
                        e.stopPropagation();
                        onClose();
                    }}
                >
                    <Icon name="exitIcon" />
                </div>
            )}
            <div className={styles['inventory-title-items-score']}>
                <div
                    className={styles['inventory-score-wrapper']}
                    style={{ '--earn': `${(score / maxScore) * 100}%` } as any}
                >
                    <div className={styles.score}>{score}</div>
                    <div className={styles['max-score-wrapper']}>
                        <Icon name="devCoin" />
                        <div className={styles.score}>{maxScore}</div>
                    </div>
                </div>
                <div className={styles['title-items-wrapper']}>
                    <Icon name="path" className={styles['type-icon']} />
                    <div className={styles['inventory-title']}>{name}</div>
                    <Divider className={styles['title-divider']} />
                    <div className={styles['inventory-title']}>{`${calcItems()} ${translate('Items')}`}</div>
                </div>
            </div>
            <Divider className={styles.divider} />
            <div className={styles['inventory-items']}>
                <UiLibrary.Grid container direction="row" justifyContent="center" alignItems="center" spacing={5}>
                    {Object.entries(inventoryItems).map(
                        ([key, value], index) =>
                            value > 0 && (
                                <UiLibrary.Grid item key={index}>
                                    <InventoryItem
                                        type={key as coreService.LearningPathContentType}
                                        numberOfItems={value}
                                    />
                                </UiLibrary.Grid>
                            )
                    )}
                </UiLibrary.Grid>
            </div>
        </div>
    );
};

export interface InventoryProps {
    name: string;
    inventoryItems: { [key in coreService.LearningPathContentType]: number };
    maxScore: number;
    score: number;
    onClose?: Function;
}

export default Inventory;
